import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { ModelHealthPage } from '@/features/model-health/ModelHealthPage';
import { useMarket } from '@/lib/market/market-context';
import { isMarket, type Market } from '@/lib/market/types';

/**
 * `/ai/model-health?market=` —— 模型健檢（ARCHITECTURE §10.1 的 `ai/model-health.tsx`）。
 *
 * 它在根層級而不在 `$market/` 底下（與 §10.1 路由樹一致），市場由 `?market=` 指定：
 * `/ai/model-health?market=us` 是一個可以分享的網址（ROADMAP §9 的美股示範路徑）。
 *
 * `?market=` 是這一頁的權威，跟 `$market` 路由同一套做法：參數同步進 MarketProvider，
 * 單一寫入點仍然是 MarketProvider；TopNav 的市場開關在這一頁會改寫 `?market=`
 * （`components/layout/MarketSwitcher.tsx`），兩者不會互相搶。
 */
export interface ModelHealthSearch {
  market?: Market;
}

export const Route = createFileRoute('/ai/model-health')({
  validateSearch: (search: Record<string, unknown>): ModelHealthSearch =>
    isMarket(search['market']) ? { market: search['market'] } : {},
  component: ModelHealthRoute,
});

function ModelHealthRoute() {
  const { market: param } = Route.useSearch();
  const { market, setMarket } = useMarket();

  useEffect(() => {
    if (param !== undefined && param !== market) setMarket(param);
  }, [param, market, setMarket]);

  return <ModelHealthPage market={param ?? market} />;
}
